"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[671],{

/***/ 10305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KU": function() { return /* binding */ IntegrationsHeroGlobeIcon; },
/* harmony export */   "Wm": function() { return /* binding */ IntegrationsHeroShieldIcon; },
/* harmony export */   "YH": function() { return /* binding */ IntegrationsHeroBoltIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var IntegrationsHeroGlobeIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.5 9H16.5",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9 1.5C10.876 3.55335 11.9422 6.22745 12 9C11.9422 11.7725 10.876 14.4467 9 16.5C7.12404 14.4467 6.0578 11.7725 6 9C6.0578 6.22745 7.12404 3.55335 9 1.5V1.5Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var IntegrationsHeroShieldIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.25 15.5175C8.58152 15.3581 9.41848 15.3581 9.75 15.5175C10.8172 15.9822 14.25 13.0575 14.25 11.8125V4.5C14.25 4.08579 13.9142 3.75 13.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V11.8125C3.75 13.0575 7.18281 15.9822 8.25 15.5175Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var IntegrationsHeroBoltIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.75 1.5L3.75 10.125H9L8.25 16.5L14.25 7.875H9L9.75 1.5Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 10461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C$": function() { return /* binding */ MethodSpecsH2HIcon; },
/* harmony export */   "T3": function() { return /* binding */ MethodSpecsWalletIcon; },
/* harmony export */   "ZL": function() { return /* binding */ MethodSpecsBookIcon; },
/* harmony export */   "cN": function() { return /* binding */ MethodSpecsGatewayCardIcon; },
/* harmony export */   "p4": function() { return /* binding */ MethodSpecsP2PIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

/** Open book — section title only. */ var MethodSpecsBookIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10 5.8335V17.5002",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2.49996 15C2.03972 15 1.66663 14.6269 1.66663 14.1667V3.33333C1.66663 2.8731 2.03972 2.5 2.49996 2.5H6.66663C8.50758 2.5 9.99996 3.99238 9.99996 5.83333C9.99996 3.99238 11.4923 2.5 13.3333 2.5H17.5C17.9602 2.5 18.3333 2.8731 18.3333 3.33333V14.1667C18.3333 14.6269 17.9602 15 17.5 15H12.5C11.1192 15 9.99996 16.1193 9.99996 17.5C9.99996 16.1193 8.88067 15 7.49996 15H2.49996",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/** Card (Gateway) — payment card outline. */ var MethodSpecsGatewayCardIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.33329 4.1665H16.6666C17.5871 4.1665 18.3333 4.9127 18.3333 5.83317V14.1665C18.3333 15.087 17.5871 15.8332 16.6666 15.8332H3.33329C2.41282 15.8332 1.66663 15.087 1.66663 14.1665V5.83317C1.66663 4.9127 2.41282 4.1665 3.33329 4.1665V4.1665",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.66663 8.3335H18.3333",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/** Card H2H — stacked blocks. */ var MethodSpecsH2HIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.33329 1.6665H16.6666C17.5871 1.6665 18.3333 2.4127 18.3333 3.33317V6.6665C18.3333 7.58698 17.5871 8.33317 16.6666 8.33317H3.33329C2.41282 8.33317 1.66663 7.58698 1.66663 6.6665V3.33317C1.66663 2.4127 2.41282 1.6665 3.33329 1.6665V1.6665",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.33329 11.6665H16.6666C17.5871 11.6665 18.3333 12.4127 18.3333 13.3332V16.6665C18.3333 17.587 17.5871 18.3332 16.6666 18.3332H3.33329C2.41282 18.3332 1.66663 17.587 1.66663 16.6665V13.3332C1.66663 12.4127 2.41282 11.6665 3.33329 11.6665V11.6665",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5 5H5.00833",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5 15H5.00833",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/** P2P — people. */ var MethodSpecsP2PIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M13.3334 17.5V15.8333C13.3334 13.9924 11.841 12.5 10 12.5H5.00002C3.15907 12.5 1.66669 13.9924 1.66669 15.8333V17.5",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M13.3333 2.60645C14.8035 2.98758 15.8301 4.31434 15.8301 5.83311C15.8301 7.35189 14.8035 8.67864 13.3333 9.05978",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.3333 17.5001V15.8334C18.3322 14.3143 17.3041 12.9882 15.8333 12.6084",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.16669 5.83333C4.16669 7.67305 5.6603 9.16667 7.50002 9.16667C9.33974 9.16667 10.8334 7.67305 10.8334 5.83333C10.8334 3.99362 9.33974 2.5 7.50002 2.5C5.6603 2.5 4.16669 3.99362 4.16669 5.83333V5.83333",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/** APM — wallet. */ var MethodSpecsWalletIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15.8333 5.83333V3.33333C15.8333 2.8731 15.4602 2.5 15 2.5H4.16667C3.24681 2.5 2.5 3.24681 2.5 4.16667C2.5 5.08652 3.24681 5.83333 4.16667 5.83333H16.6667C17.1269 5.83333 17.5 6.20643 17.5 6.66667V10H15C14.0801 10 13.3333 10.7468 13.3333 11.6667C13.3333 12.5865 14.0801 13.3333 15 13.3333H17.5C17.9602 13.3333 18.3333 12.9602 18.3333 12.5V10.8333C18.3333 10.3731 17.9602 10 17.5 10",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2.5 4.1665V15.8332C2.5 16.7536 3.24619 17.4998 4.16667 17.4998H16.6667C17.1269 17.4998 17.5 17.1267 17.5 16.6665V13.3332",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};


/***/ }),

/***/ 85671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Tp": function() { return /* binding */ getSolutionPageBySlug; },
  "Oz": function() { return /* binding */ solutionPages; }
});

// UNUSED EXPORTS: solutionPageSlugs

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/icons/BugHandleV4Icon.tsx

var BugHandleV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20 5C18.3424 5 16.7527 5.65848 15.5806 6.83058C14.4085 8.00269 13.75 9.5924 13.75 11.25V12.5H26.25V11.25C26.25 9.5924 25.5915 8.00269 24.4194 6.83058C23.2473 5.65848 21.6576 5 20 5ZM11.25 11.25V12.5H6.25C5.58696 12.5 4.95107 12.7634 4.48223 13.2322C4.01339 13.7011 3.75 14.337 3.75 15V31.875C3.75 34.9279 6.32214 37.5 9.375 37.5H30.625C33.641 37.5 36.25 35.0618 36.25 31.9727V15C36.25 14.337 35.9866 13.7011 35.5178 13.2322C35.0489 12.7634 34.413 12.5 33.75 12.5H28.75V11.25C28.75 8.92936 27.8281 6.70376 26.1872 5.06282C24.5462 3.42187 22.3206 2.5 20 2.5C17.6794 2.5 15.4538 3.42187 13.8128 5.06282C12.1719 6.70376 11.25 8.92936 11.25 11.25ZM6.25 15H12.5H27.5H33.75V31.9727C33.75 33.6085 32.334 35 30.625 35H9.375C7.70286 35 6.25 33.5471 6.25 31.875L6.25 15ZM13.75 17.5C13.75 16.8096 13.1904 16.25 12.5 16.25C11.8096 16.25 11.25 16.8096 11.25 17.5V18.75C11.25 21.0706 12.1719 23.2962 13.8128 24.9372C15.4538 26.5781 17.6794 27.5 20 27.5C22.3206 27.5 24.5462 26.5781 26.1872 24.9372C27.8281 23.2962 28.75 21.0706 28.75 18.75V17.5C28.75 16.8096 28.1904 16.25 27.5 16.25C26.8096 16.25 26.25 16.8096 26.25 17.5V18.75C26.25 20.4076 25.5915 21.9973 24.4194 23.1694C23.2473 24.3415 21.6576 25 20 25C18.3424 25 16.7527 24.3415 15.5806 23.1694C14.4085 21.9973 13.75 20.4076 13.75 18.75V17.5Z",
            fill: "#CEFFF4",
            fillOpacity: "0.5"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/icons/BusinessV4Icon.tsx

var BusinessV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.25 3.75C5.91848 3.75 5.60054 3.8817 5.36612 4.11612C5.1317 4.35054 5 4.66848 5 5V36.25H12.5V32.5C12.5 31.8096 13.0596 31.25 13.75 31.25C14.4404 31.25 15 31.8096 15 32.5V36.25H22.5V5C22.5 4.66848 22.3683 4.35054 22.1339 4.11612C21.8995 3.8817 21.5815 3.75 21.25 3.75H6.25ZM25 16.25V36.25H35V17.5C35 17.1685 34.8683 16.8505 34.6339 16.6161C34.3995 16.3817 34.0815 16.25 33.75 16.25H25ZM23.602 38.7413C23.6505 38.7471 23.6999 38.75 23.75 38.75H36.25C36.9404 38.75 37.5 38.1904 37.5 37.5V17.5C37.5 16.5054 37.1049 15.5516 36.4016 14.8484C35.6984 14.1451 34.7446 13.75 33.75 13.75H25V5C25 4.00544 24.6049 3.05161 23.9017 2.34835C23.1984 1.64509 22.2446 1.25 21.25 1.25H6.25C5.25544 1.25 4.30161 1.64509 3.59835 2.34835C2.89509 3.05161 2.5 4.00544 2.5 5V37.5C2.5 38.1904 3.05964 38.75 3.75 38.75H23.4375C23.4927 38.75 23.5476 38.7471 23.602 38.7413Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.6625 33.7398C7.40362 33.7737 7.14063 33.7256 6.91045 33.6024C6.68027 33.4792 6.49445 33.287 6.37907 33.0528C6.2637 32.8186 6.22455 32.5541 6.26714 32.2965C6.30972 32.0389 6.4319 31.8011 6.61652 31.6165C6.80113 31.4319 7.03893 31.3097 7.29652 31.2671C7.55411 31.2246 7.81857 31.2637 8.05278 31.3791C8.28699 31.4944 8.4792 31.6803 8.60242 31.9104C8.72565 32.1406 8.7737 32.4036 8.73984 32.6625C8.70411 32.9357 8.57911 33.1895 8.38428 33.3843C8.18945 33.5791 7.93571 33.7041 7.6625 33.7398Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.6625 27.4898C7.40362 27.5237 7.14063 27.4756 6.91045 27.3524C6.68027 27.2292 6.49445 27.037 6.37907 26.8028C6.2637 26.5686 6.22455 26.3041 6.26714 26.0465C6.30972 25.7889 6.4319 25.5511 6.61652 25.3665C6.80113 25.1819 7.03893 25.0597 7.29652 25.0171C7.55411 24.9746 7.81857 25.0137 8.05278 25.1291C8.28699 25.2444 8.4792 25.4303 8.60242 25.6604C8.72565 25.8906 8.7737 26.1536 8.73984 26.4125C8.70411 26.6857 8.57911 26.9395 8.38428 27.1343C8.18945 27.3291 7.93571 27.4541 7.6625 27.4898Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.6625 21.2398C7.40362 21.2737 7.14063 21.2256 6.91045 21.1024C6.68027 20.9792 6.49445 20.787 6.37907 20.5528C6.2637 20.3186 6.22455 20.0541 6.26714 19.7965C6.30972 19.5389 6.4319 19.3011 6.61652 19.1165C6.80113 18.9319 7.03893 18.8097 7.29652 18.7671C7.55411 18.7246 7.81857 18.7637 8.05278 18.8791C8.28699 18.9944 8.4792 19.1803 8.60242 19.4104C8.72565 19.6406 8.7737 19.9036 8.73984 20.1625C8.70411 20.4357 8.57911 20.6895 8.38428 20.8843C8.18945 21.0791 7.93571 21.2041 7.6625 21.2398Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.6625 14.9898C7.40362 15.0237 7.14063 14.9756 6.91045 14.8524C6.68027 14.7292 6.49445 14.537 6.37907 14.3028C6.2637 14.0686 6.22455 13.8041 6.26714 13.5465C6.30972 13.2889 6.4319 13.0511 6.61652 12.8665C6.80113 12.6819 7.03893 12.5597 7.29652 12.5171C7.55411 12.4746 7.81857 12.5137 8.05278 12.6291C8.28699 12.7444 8.4792 12.9303 8.60242 13.1604C8.72565 13.3906 8.7737 13.6536 8.73984 13.9125C8.70411 14.1857 8.57911 14.4395 8.38428 14.6343C8.18945 14.8291 7.93571 14.9541 7.6625 14.9898Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.6625 8.73984C7.40362 8.7737 7.14063 8.72565 6.91045 8.60242C6.68027 8.4792 6.49445 8.28699 6.37907 8.05278C6.2637 7.81857 6.22455 7.55411 6.26714 7.29652C6.30972 7.03893 6.4319 6.80113 6.61652 6.61652C6.80113 6.4319 7.03893 6.30972 7.29652 6.26714C7.55411 6.22455 7.81857 6.2637 8.05278 6.37907C8.28699 6.49445 8.4792 6.68027 8.60242 6.91045C8.72565 7.14063 8.7737 7.40362 8.73984 7.6625C8.70411 7.93571 8.57911 8.18945 8.38428 8.38428C8.18945 8.57911 7.93571 8.70411 7.6625 8.73984Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.9125 27.4898C13.6536 27.5237 13.3906 27.4756 13.1604 27.3524C12.9303 27.2292 12.7444 27.037 12.6291 26.8028C12.5137 26.5686 12.4746 26.3041 12.5171 26.0465C12.5597 25.7889 12.6819 25.5511 12.8665 25.3665C13.0511 25.1819 13.2889 25.0597 13.5465 25.0171C13.8041 24.9746 14.0686 25.0137 14.3028 25.1291C14.537 25.2444 14.7292 25.4303 14.8524 25.6604C14.9756 25.8906 15.0237 26.1536 14.9898 26.4125C14.9541 26.6857 14.8291 26.9395 14.6343 27.1343C14.4395 27.3291 14.1857 27.4541 13.9125 27.4898Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.9125 21.2398C13.6536 21.2737 13.3906 21.2256 13.1604 21.1024C12.9303 20.9792 12.7444 20.787 12.6291 20.5528C12.5137 20.3186 12.4746 20.0541 12.5171 19.7965C12.5597 19.5389 12.6819 19.3011 12.8665 19.1165C13.0511 18.9319 13.2889 18.8097 13.5465 18.7671C13.8041 18.7246 14.0686 18.7637 14.3028 18.8791C14.537 18.9944 14.7292 19.1803 14.8524 19.4104C14.9756 19.6406 15.0237 19.9036 14.9898 20.1625C14.9541 20.4357 14.8291 20.6895 14.6343 20.8843C14.4395 21.0791 14.1857 21.2041 13.9125 21.2398Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.9125 14.9898C13.6536 15.0237 13.3906 14.9756 13.1604 14.8524C12.9303 14.7292 12.7444 14.537 12.6291 14.3028C12.5137 14.0686 12.4746 13.8041 12.5171 13.5465C12.5597 13.2889 12.6819 13.0511 12.8665 12.8665C13.0511 12.6819 13.2889 12.5597 13.5465 12.5171C13.8041 12.4746 14.0686 12.5137 14.3028 12.6291C14.537 12.7444 14.7292 12.9303 14.8524 13.1604C14.9756 13.3906 15.0237 13.6536 14.9898 13.9125C14.9541 14.1857 14.8291 14.4395 14.6343 14.6343C14.4395 14.8291 14.1857 14.9541 13.9125 14.9898Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.9125 8.73984C13.6536 8.7737 13.3906 8.72565 13.1604 8.60242C12.9303 8.4792 12.7444 8.28699 12.6291 8.05278C12.5137 7.81857 12.4746 7.55411 12.5171 7.29652C12.5597 7.03893 12.6819 6.80113 12.8665 6.61652C13.0511 6.4319 13.2889 6.30972 13.5465 6.26714C13.8041 6.22455 14.0686 6.2637 14.3028 6.37907C14.537 6.49445 14.7292 6.68027 14.8524 6.91045C14.9756 7.14063 15.0237 7.40362 14.9898 7.6625C14.9541 7.93571 14.8291 8.18945 14.6343 8.38428C14.4395 8.57911 14.1857 8.70411 13.9125 8.73984Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1625 33.7398C19.9036 33.7737 19.6406 33.7256 19.4104 33.6024C19.1803 33.4792 18.9944 33.287 18.8791 33.0528C18.7637 32.8186 18.7246 32.5541 18.7671 32.2965C18.8097 32.0389 18.9319 31.8011 19.1165 31.6165C19.3011 31.4319 19.5389 31.3097 19.7965 31.2671C20.0541 31.2246 20.3186 31.2637 20.5528 31.3791C20.787 31.4944 20.9792 31.6803 21.1024 31.9104C21.2256 32.1406 21.2737 32.4036 21.2398 32.6625C21.2041 32.9357 21.0791 33.1895 20.8843 33.3843C20.6895 33.5791 20.4357 33.7041 20.1625 33.7398Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1625 27.4898C19.9036 27.5237 19.6406 27.4756 19.4104 27.3524C19.1803 27.2292 18.9944 27.037 18.8791 26.8028C18.7637 26.5686 18.7246 26.3041 18.7671 26.0465C18.8097 25.7889 18.9319 25.5511 19.1165 25.3665C19.3011 25.1819 19.5389 25.0597 19.7965 25.0171C20.0541 24.9746 20.3186 25.0137 20.5528 25.1291C20.787 25.2444 20.9792 25.4303 21.1024 25.6604C21.2256 25.8906 21.2737 26.1536 21.2398 26.4125C21.2041 26.6857 21.0791 26.9395 20.8843 27.1343C20.6895 27.3291 20.4357 27.4541 20.1625 27.4898Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1625 21.2398C19.9036 21.2737 19.6406 21.2256 19.4104 21.1024C19.1803 20.9792 18.9944 20.787 18.8791 20.5528C18.7637 20.3186 18.7246 20.0541 18.7671 19.7965C18.8097 19.5389 18.9319 19.3011 19.1165 19.1165C19.3011 18.9319 19.5389 18.8097 19.7965 18.7671C20.0541 18.7246 20.3186 18.7637 20.5528 18.8791C20.787 18.9944 20.9792 19.1803 21.1024 19.4104C21.2256 19.6406 21.2737 19.9036 21.2398 20.1625C21.2041 20.4357 21.0791 20.6895 20.8843 20.8843C20.6895 21.0791 20.4357 21.2041 20.1625 21.2398Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.8856 14.6349C21.3722 14.1482 21.3702 13.3573 20.8811 12.8682C20.3921 12.3791 19.6011 12.3772 19.1145 12.8638C18.6278 13.3504 18.6298 14.1414 19.1189 14.6305C19.608 15.1195 20.3989 15.1215 20.8856 14.6349Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.1625 8.73984C19.9036 8.7737 19.6406 8.72565 19.4104 8.60242C19.1803 8.4792 18.9944 8.28699 18.8791 8.05278C18.7637 7.81857 18.7246 7.55411 18.7671 7.29652C18.8097 7.03893 18.9319 6.80113 19.1165 6.61652C19.3011 6.4319 19.5389 6.30972 19.7965 6.26714C20.0541 6.22455 20.3186 6.2637 20.5528 6.37907C20.787 6.49445 20.9792 6.68027 21.1024 6.91045C21.2256 7.14063 21.2737 7.40362 21.2398 7.6625C21.2041 7.93571 21.0791 8.18945 20.8843 8.38428C20.6895 8.57911 20.4357 8.70411 20.1625 8.73984Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.25 31.25C31.0028 31.25 30.7611 31.3233 30.5555 31.4607C30.35 31.598 30.1898 31.7932 30.0951 32.0216C30.0005 32.2501 29.9758 32.5014 30.024 32.7439C30.0723 32.9863 30.1913 33.2091 30.3661 33.3839C30.5409 33.5587 30.7637 33.6777 31.0061 33.726C31.2486 33.7742 31.4999 33.7495 31.7284 33.6549C31.9568 33.5602 32.152 33.4 32.2893 33.1945C32.4267 32.9889 32.5 32.7472 32.5 32.5C32.5 32.1685 32.3683 31.8505 32.1339 31.6161C31.8995 31.3817 31.5815 31.25 31.25 31.25Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.25 25C31.0028 25 30.7611 25.0733 30.5555 25.2107C30.35 25.348 30.1898 25.5432 30.0951 25.7716C30.0005 26.0001 29.9758 26.2514 30.024 26.4939C30.0723 26.7363 30.1913 26.9591 30.3661 27.1339C30.5409 27.3087 30.7637 27.4277 31.0061 27.476C31.2486 27.5242 31.4999 27.4995 31.7284 27.4049C31.9568 27.3102 32.152 27.15 32.2893 26.9445C32.4267 26.7389 32.5 26.4972 32.5 26.25C32.5 25.9185 32.3683 25.6005 32.1339 25.3661C31.8995 25.1317 31.5815 25 31.25 25Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.25 18.75C31.0028 18.75 30.7611 18.8233 30.5555 18.9607C30.35 19.098 30.1898 19.2932 30.0951 19.5216C30.0005 19.7501 29.9758 20.0014 30.024 20.2439C30.0723 20.4863 30.1913 20.7091 30.3661 20.8839C30.5409 21.0587 30.7637 21.1777 31.0061 21.226C31.2486 21.2742 31.4999 21.2495 31.7284 21.1549C31.9568 21.0602 32.152 20.9 32.2893 20.6945C32.4267 20.4889 32.5 20.2472 32.5 20C32.5 19.6685 32.3683 19.3505 32.1339 19.1161C31.8995 18.8817 31.5815 18.75 31.25 18.75Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.25 31.25C26.0028 31.25 25.7611 31.3233 25.5555 31.4607C25.35 31.598 25.1898 31.7932 25.0951 32.0216C25.0005 32.2501 24.9758 32.5014 25.024 32.7439C25.0723 32.9863 25.1913 33.2091 25.3661 33.3839C25.5409 33.5587 25.7637 33.6777 26.0061 33.726C26.2486 33.7742 26.4999 33.7495 26.7284 33.6549C26.9568 33.5602 27.152 33.4 27.2893 33.1945C27.4267 32.9889 27.5 32.7472 27.5 32.5C27.5 32.1685 27.3683 31.8505 27.1339 31.6161C26.8995 31.3817 26.5815 31.25 26.25 31.25Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.25 25C26.0028 25 25.7611 25.0733 25.5555 25.2107C25.35 25.348 25.1898 25.5432 25.0951 25.7716C25.0005 26.0001 24.9758 26.2514 25.024 26.4939C25.0723 26.7363 25.1913 26.9591 25.3661 27.1339C25.5409 27.3087 25.7637 27.4277 26.0061 27.476C26.2486 27.5242 26.4999 27.4995 26.7284 27.4049C26.9568 27.3102 27.152 27.15 27.2893 26.9445C27.4267 26.7389 27.5 26.4972 27.5 26.25C27.5 25.9185 27.3683 25.6005 27.1339 25.3661C26.8995 25.1317 26.5815 25 26.25 25Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.25 18.75C26.0028 18.75 25.7611 18.8233 25.5555 18.9607C25.35 19.098 25.1898 19.2932 25.0951 19.5216C25.0005 19.7501 24.9758 20.0014 25.024 20.2439C25.0723 20.4863 25.1913 20.7091 25.3661 20.8839C25.5409 21.0587 25.7637 21.1777 26.0061 21.226C26.2486 21.2742 26.4999 21.2495 26.7284 21.1549C26.9568 21.0602 27.152 20.9 27.2893 20.6945C27.4267 20.4889 27.5 20.2472 27.5 20C27.5 19.6685 27.3683 19.3505 27.1339 19.1161C26.8995 18.8817 26.5815 18.75 26.25 18.75Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/CardV4Icon.tsx

var CardV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.125 8.75C6.39911 8.75 5 10.1491 5 11.875V12.6562H35V11.875C35 10.1491 33.6009 8.75 31.875 8.75H8.125ZM5 28.125V17.3438H35V28.125C35 29.8509 33.6009 31.25 31.875 31.25H8.125C6.39911 31.25 5 29.8509 5 28.125ZM2.5 11.875C2.5 8.7684 5.0184 6.25 8.125 6.25H31.875C34.9816 6.25 37.5 8.7684 37.5 11.875V28.125C37.5 31.2316 34.9816 33.75 31.875 33.75H8.125C5.0184 33.75 2.5 31.2316 2.5 28.125V11.875ZM10 21.0938C8.70558 21.0938 7.65625 22.1431 7.65625 23.4375V25C7.65625 26.2944 8.70558 27.3438 10 27.3438H13.75C15.0444 27.3438 16.0938 26.2944 16.0938 25V23.4375C16.0938 22.1431 15.0444 21.0938 13.75 21.0938H10Z",
            fill: "#CEFFF4",
            fillOpacity: "0.5"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/icons/ExtensionPuzzleV4Icon.tsx

var ExtensionPuzzleV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M26.9609 37.5002H21.4062C20.6328 37.5002 20 36.8674 20 36.094V33.9299C20 33.0706 19.5859 32.4924 19.2422 32.1487C18.6328 31.5549 17.7578 31.2268 16.8281 31.2502C15.1641 31.2893 13.75 32.7581 13.75 34.4612V36.094C13.75 36.8674 13.1172 37.5002 12.3438 37.5002H6.84375C4.45312 37.4924 2.50781 35.5471 2.5 33.1565V27.6565C2.5 26.8831 3.13281 26.2502 3.90625 26.2502H6.07031C6.78906 26.2502 7.48438 25.9456 8.03125 25.3909C8.64844 24.7659 9 23.9143 8.98438 23.0549C8.96094 21.3987 7.60156 20.0002 6.00781 20.0002H3.90625C3.13281 20.0002 2.5 19.3674 2.5 18.594V13.094C2.50781 10.7034 4.45312 8.75804 6.84375 8.75023H11.7891V7.61742C11.7891 7.58617 11.7891 7.55492 11.7891 7.53148C11.8359 4.71117 14.1719 2.45335 17 2.50023C19.7734 2.5471 22.0312 4.87523 22.0312 7.67992V8.75023H26.9688C29.3281 8.75023 31.2578 10.6721 31.2578 13.0393V17.9768H32.3281C35.1875 17.9768 37.5078 20.2424 37.5078 23.0237C37.5078 25.8831 35.2109 28.2112 32.3906 28.2112H31.25V33.2112C31.25 35.5784 29.3281 37.5002 26.9609 37.5002ZM5 28.7502V33.1565C5 34.1721 5.83594 35.0002 6.85156 35.0002H11.25V34.4612C11.25 32.9924 11.8203 31.5862 12.8594 30.5002C13.9062 29.4065 15.2969 28.7893 16.7656 28.7502C18.3594 28.7112 19.8984 29.2971 20.9844 30.3596C21.9609 31.3127 22.4922 32.5784 22.4922 33.9221V35.0002H26.9531C27.9375 35.0002 28.7422 34.1956 28.7422 33.2112V27.1174C28.7422 26.344 29.375 25.7112 30.1484 25.7112H32.375C33.8203 25.7112 34.9922 24.5081 34.9922 23.0237C34.9922 21.6174 33.7891 20.4768 32.3125 20.4768H30.1562C29.3828 20.4768 28.75 19.844 28.75 19.0705V13.0393C28.75 12.0549 27.9453 11.2502 26.9609 11.2502H20.9297C20.1562 11.2502 19.5234 10.6174 19.5234 9.84398V7.67992C19.5234 6.22679 18.3672 5.02367 16.9531 5.00023C16.25 4.99242 15.5938 5.25023 15.0859 5.7346C14.5859 6.21898 14.2969 6.87523 14.2891 7.57054V7.61742V9.84398C14.2891 10.6174 13.6562 11.2502 12.8828 11.2502H6.84375C5.82812 11.2502 5 12.0862 5 13.1018V17.5002H6.00781C7.45312 17.5002 8.82031 18.0862 9.86719 19.1565C10.8906 20.2034 11.4688 21.5784 11.4844 23.0159C11.5078 24.5393 10.8984 26.0393 9.8125 27.1409C8.78906 28.1799 7.46094 28.7502 6.07031 28.7502H5Z",
            fill: "#CEFFF4",
            fillOpacity: "0.5"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/icons/GameControllerV4Icon.tsx

var GameControllerV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M37.7422 19.1718C36.0859 11.6796 33.5937 7.67957 29.8906 6.58582C29.1094 6.35925 28.3047 6.24988 27.5 6.24988C26.4297 6.24988 25.4922 6.50769 24.5078 6.78894C23.3203 7.12488 21.9687 7.49988 20 7.49988C18.0312 7.49988 16.6797 7.12488 15.4922 6.78894C14.5078 6.5155 13.5703 6.24988 12.5078 6.24988C11.6719 6.24207 10.8437 6.35925 10.039 6.58582L10.0234 6.59363C6.34373 7.67957 3.84373 11.6796 2.16404 19.1718C0.359355 27.2264 1.24998 32.3202 4.66404 33.4999C5.16404 33.6718 5.65623 33.7499 6.12498 33.7499C8.46092 33.7499 10.3359 31.8046 11.6172 30.2108C13.2656 28.1561 15.3047 27.4921 20 27.4921C24.6875 27.4921 26.625 28.1249 28.2969 30.2108C29.3515 31.5233 30.3437 32.4374 31.3359 33.0155C32.6562 33.7811 33.9765 33.953 35.2578 33.5155C37.2734 32.828 38.4297 31.0077 38.6953 28.1014C38.8906 25.8827 38.5859 22.9608 37.7422 19.1718ZM34.4453 31.1483C34.0156 31.2968 32.7265 31.7343 30.2422 28.6483C27.7734 25.578 24.7422 24.9921 20 24.9921C17.2344 24.9921 15.3203 25.2186 13.7812 25.7343C12.1172 26.2889 10.8125 27.2186 9.66404 28.6405C7.46873 31.3749 6.27342 31.4061 5.47654 31.1327C3.53904 30.4608 3.19529 25.9764 4.60154 19.703C6.03904 13.2811 8.03904 9.77332 10.7187 8.97644C11.2969 8.81238 11.8906 8.73425 12.5 8.74207C13.2265 8.74207 13.9297 8.93738 14.8125 9.18738C16.0937 9.55457 17.6875 9.99988 20 9.99988C22.3125 9.99988 23.9062 9.55457 25.1797 9.19519C26.0703 8.94519 26.7656 8.74988 27.5 8.74988C27.5078 8.74988 27.5156 8.74988 27.5312 8.74988C28.0937 8.74988 28.6484 8.828 29.1797 8.98425C31.875 9.78113 33.8828 13.2889 35.2969 19.7108C36.8047 26.4921 36.5078 30.4452 34.4453 31.1483Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.8125 19.0624C23.6754 19.0624 24.375 18.3628 24.375 17.4999C24.375 16.6369 23.6754 15.9374 22.8125 15.9374C21.9495 15.9374 21.25 16.6369 21.25 17.4999C21.25 18.3628 21.9495 19.0624 22.8125 19.0624Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.25 19.3749C25.3906 19.3749 24.6875 20.078 24.6875 20.9374C24.6875 21.7968 25.3906 22.4999 26.25 22.4999C27.1094 22.4999 27.8125 21.8046 27.8125 20.9374C27.8125 20.078 27.1094 19.3749 26.25 19.3749Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.25 15.6249C27.1129 15.6249 27.8125 14.9253 27.8125 14.0624C27.8125 13.1994 27.1129 12.4999 26.25 12.4999C25.387 12.4999 24.6875 13.1994 24.6875 14.0624C24.6875 14.9253 25.387 15.6249 26.25 15.6249Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.6875 19.0624C30.5504 19.0624 31.25 18.3628 31.25 17.4999C31.25 16.6369 30.5504 15.9374 29.6875 15.9374C28.8245 15.9374 28.125 16.6369 28.125 17.4999C28.125 18.3628 28.8245 19.0624 29.6875 19.0624Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.25 16.2499H13.75V13.7499C13.75 13.0624 13.1875 12.4999 12.5 12.4999C11.8125 12.4999 11.25 13.0624 11.25 13.7499V16.2499H8.74996C8.06246 16.2499 7.49996 16.8124 7.49996 17.4999C7.49996 18.1874 8.06246 18.7499 8.74996 18.7499H11.25V21.2499C11.25 21.9374 11.8125 22.4999 12.5 22.4999C13.1875 22.4999 13.75 21.9374 13.75 21.2499V18.7499H16.25C16.9375 18.7499 17.5 18.1874 17.5 17.4999C17.5 16.8124 16.9375 16.2499 16.25 16.2499Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/StatsChartV4Icon.tsx

var StatsChartV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.25 26.25V36.25H7.5V26.25H6.25ZM3.75 25.625C3.75 24.5895 4.58947 23.75 5.625 23.75H8.125C9.16053 23.75 10 24.5895 10 25.625V36.875C10 37.9105 9.16053 38.75 8.125 38.75H5.625C4.58947 38.75 3.75 37.9105 3.75 36.875V25.625Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.75 18.75V36.25H25V18.75H23.75ZM21.25 18.125C21.25 17.0895 22.0895 16.25 23.125 16.25H25.625C26.6605 16.25 27.5 17.0895 27.5 18.125V36.875C27.5 37.9105 26.6605 38.75 25.625 38.75H23.125C22.0895 38.75 21.25 37.9105 21.25 36.875V18.125Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.5 10V36.25H33.75V10H32.5ZM30 9.375C30 8.33947 30.8395 7.5 31.875 7.5H34.375C35.4105 7.5 36.25 8.33947 36.25 9.375V36.875C36.25 37.9105 35.4105 38.75 34.375 38.75H31.875C30.8395 38.75 30 37.9105 30 36.875V9.375Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15 3.75V36.25H16.25V3.75H15ZM12.5 3.125C12.5 2.08947 13.3395 1.25 14.375 1.25H16.875C17.9105 1.25 18.75 2.08947 18.75 3.125V36.875C18.75 37.9105 17.9105 38.75 16.875 38.75H14.375C13.3395 38.75 12.5 37.9105 12.5 36.875V3.125Z",
                fill: "#CEFFF4",
                fillOpacity: "0.5"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/icons/TrendingUpV4Icon.tsx

var TrendingUpV4Icon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M26.25 11.25C26.25 10.5596 26.8096 10 27.5 10H36.25C36.9404 10 37.5 10.5596 37.5 11.25V20C37.5 20.6904 36.9404 21.25 36.25 21.25C35.5596 21.25 35 20.6904 35 20V14.2678L25.152 24.1158C25.1519 24.1158 25.1519 24.1159 25.1519 24.1159C24.8036 24.4642 24.3902 24.7404 23.9353 24.9289C23.4802 25.1174 22.9925 25.2145 22.5 25.2145C22.0075 25.2145 21.5198 25.1174 21.0647 24.9289C20.6097 24.7404 20.1963 24.4641 19.848 24.1158L15.8841 20.1519L15.884 20.1518C15.7679 20.0356 15.6301 19.9435 15.4784 19.8807C15.3267 19.8179 15.1642 19.7855 15 19.7855C14.8358 19.7855 14.6733 19.8179 14.5216 19.8807C14.3699 19.9435 14.2321 20.0356 14.116 20.1518L14.1159 20.1519L4.63388 29.6339C4.14573 30.122 3.35427 30.122 2.86612 29.6339C2.37796 29.1457 2.37796 28.3543 2.86612 27.8661L12.348 18.3842C12.6963 18.0359 13.1097 17.7596 13.5647 17.5711C14.0198 17.3826 14.5075 17.2855 15 17.2855C15.4925 17.2855 15.9802 17.3826 16.4353 17.5711C16.8903 17.7596 17.3037 18.0359 17.652 18.3842L21.6159 22.3481L21.616 22.3482C21.7321 22.4644 21.8699 22.5565 22.0216 22.6193C22.1733 22.6821 22.3358 22.7145 22.5 22.7145C22.6642 22.7145 22.8267 22.6821 22.9784 22.6193C23.1301 22.5565 23.2679 22.4644 23.384 22.3482L23.3841 22.3481L33.2322 12.5H27.5C26.8096 12.5 26.25 11.9404 26.25 11.25Z",
            fill: "#CEFFF4",
            fillOpacity: "0.5"
        })
    });
};

// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsHero/IntegrationsHeroIcons.tsx
var IntegrationsHeroIcons = __webpack_require__(10305);
// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsMethodSpecsBlock/MethodSpecsIcons.tsx
var MethodSpecsIcons = __webpack_require__(10461);
;// CONCATENATED MODULE: ./src/components/landingV4/SolutionPage/solutionPagesData.ts









var solutionPages = [
    {
        slug: "e-commerce",
        metaTitleSuffix: "E-commerce",
        docDescription: "Turn browsers into buyers with adaptive checkout, instant transaction processing, and broad payment-method support.",
        solutionEyebrowLabel: "SOLUTION / E-COMMERCE",
        headline: "Drive Sales with Seamless Checkout",
        subheadline: "Turn browsers into buyers with a payment form that adapts to any device. We maximize conversion rates through instant transaction processing and support for all popular payment methods.",
        featuresSectionTitle: "Key Features",
        ctaHeadline: "Ready to upgrade your checkout?",
        ctaVisualCaption: "Payment flows built for conversions",
        card: {
            title: "E-commerce",
            description: "High conversion checkout, fast payouts, and granular controls",
            Icon: BusinessV4Icon
        },
        features: [
            {
                id: "one-click",
                title: "One-Click Payments",
                description: "Secure card saving for effortless repeat purchases.",
                Icon: MethodSpecsIcons/* MethodSpecsGatewayCardIcon */.cN
            },
            {
                id: "routing",
                title: "Smart Routing",
                description: "Minimize declines with intelligent transaction pathing.",
                Icon: MethodSpecsIcons/* MethodSpecsH2HIcon */.C$
            },
            {
                id: "refunds",
                title: "Easy Refunds",
                description: "Manage full or partial returns directly via the dashboard.",
                Icon: MethodSpecsIcons/* MethodSpecsWalletIcon */.T3
            }, 
        ]
    },
    {
        slug: "marketplaces",
        metaTitleSuffix: "Marketplaces",
        docDescription: "Automate payouts to many vendors: split a single customer payment, hold commission, and route funds with ease.",
        solutionEyebrowLabel: "SOLUTION / MARKETPLACES",
        headline: "Complex Settlements Made Simple",
        subheadline: "Automate payouts to hundreds of vendors. Our solution allows you to accept a single payment from a customer and instantly split it, holding your commission and routing the rest.",
        featuresSectionTitle: "Security & Escrow",
        ctaHeadline: "Ready to simplify marketplace payouts?",
        ctaVisualCaption: "Splits, escrow, and vendor automation",
        card: {
            title: "Marketplaces",
            description: "High conversion checkout, fast payouts, and granular controls",
            Icon: BugHandleV4Icon
        },
        features: [
            {
                id: "escrow",
                title: "Secure Deals",
                description: "Hold funds until the customer confirms delivery.",
                Icon: IntegrationsHeroIcons/* IntegrationsHeroShieldIcon */.Wm
            },
            {
                id: "onboarding",
                title: "Automated Onboarding",
                description: "Streamlined KYC for your sub-merchants.",
                Icon: MethodSpecsIcons/* MethodSpecsP2PIcon */.p4
            },
            {
                id: "reporting",
                title: "Unified Reporting",
                description: "Transparent data for every vendor in one place.",
                Icon: MethodSpecsIcons/* MethodSpecsH2HIcon */.C$
            }, 
        ]
    },
    {
        slug: "gaming-and-digital-goods",
        metaTitleSuffix: "Gaming & Digital Goods",
        docDescription: "Frictionless microtransactions and in-game purchases with robust fraud protection and global reach.",
        solutionEyebrowLabel: "SOLUTION / GAMING & DIGITAL GOODS",
        headline: "Payments at the Speed of Play",
        subheadline: "Microtransactions and in-game currency purchases should be invisible. We reduce friction so players stay focused on the game, backed by top-tier fraud protection.",
        featuresSectionTitle: "Tech Stack",
        ctaHeadline: "Ready to monetize without friction?",
        ctaVisualCaption: "Built for gamers worldwide",
        card: {
            title: "Gaming & Digital goods",
            description: "High conversion checkout, fast payouts, and granular controls",
            Icon: GameControllerV4Icon
        },
        features: [
            {
                id: "iap",
                title: "In-App Purchases",
                description: "Seamless integration for mobile and desktop gaming.",
                Icon: MethodSpecsIcons/* MethodSpecsGatewayCardIcon */.cN
            },
            {
                id: "fraud",
                title: "Advanced Anti-Fraud",
                description: "Protect your revenue from chargeback abuse.",
                Icon: IntegrationsHeroIcons/* IntegrationsHeroShieldIcon */.Wm
            },
            {
                id: "reach",
                title: "Global Reach",
                description: "Accept payments from gamers in any currency, anywhere.",
                Icon: IntegrationsHeroIcons/* IntegrationsHeroGlobeIcon */.KU
            }, 
        ]
    },
    {
        slug: "subscription-services",
        metaTitleSuffix: "Subscription Services",
        docDescription: "Automate recurring billing, failed-payment recovery, and self-service subscription management.",
        solutionEyebrowLabel: "SOLUTION / SUBSCRIPTION SERVICES",
        headline: "Predictable Growth with Zero Effort",
        subheadline: "Automate your subscription billing. Our system handles recurring charges and automatically notifies customers about expiring cards.",
        featuresSectionTitle: "Retention Tools",
        ctaHeadline: "Ready to grow recurring revenue?",
        ctaVisualCaption: "Billing that keeps subscribers on board",
        card: {
            title: "Subscription services",
            description: "High conversion checkout, fast payouts, and granular controls",
            Icon: ExtensionPuzzleV4Icon
        },
        features: [
            {
                id: "retries",
                title: "Smart Retries",
                description: "Intelligent logic to recover failed payments and reduce churn.",
                Icon: IntegrationsHeroIcons/* IntegrationsHeroBoltIcon */.YH
            },
            {
                id: "plans",
                title: "Flexible Plans",
                description: "Easily manage trials, tiers, and billing cycles.",
                Icon: MethodSpecsIcons/* MethodSpecsH2HIcon */.C$
            },
            {
                id: "portal",
                title: "Subscription Portal",
                description: "Give users control over their payment methods.",
                Icon: MethodSpecsIcons/* MethodSpecsP2PIcon */.p4
            }, 
        ]
    },
    {
        slug: "fintech",
        metaTitleSuffix: "Fintech",
        docDescription: "API-first infrastructure with white-label options, transfers, PCI alignment, and high availability.",
        solutionEyebrowLabel: "SOLUTION / FINTECH",
        headline: "Built for Financial Innovators",
        subheadline: "Build your own financial products on top of our robust API. We provide White Label solutions and tools for instant fund transfers between accounts and cards.",
        featuresSectionTitle: "Compliance & Reliability",
        ctaHeadline: "Ready to ship on scalable payments infrastructure?",
        ctaVisualCaption: "Compliance-ready building blocks",
        card: {
            title: "Fintech",
            description: "High conversion checkout, fast payouts, and granular controls",
            Icon: CardV4Icon
        },
        features: [
            {
                id: "security",
                title: "Total Security",
                description: "Full PCI DSS compliance and regional regulatory alignment.",
                Icon: IntegrationsHeroIcons/* IntegrationsHeroShieldIcon */.Wm
            },
            {
                id: "uptime",
                title: "High Availability",
                description: "99.99% uptime to keep your services running 24/7.",
                Icon: IntegrationsHeroIcons/* IntegrationsHeroBoltIcon */.YH
            },
            {
                id: "logic",
                title: "Customizable Logic",
                description: "Set your own limits and risk-monitoring rules.",
                Icon: MethodSpecsIcons/* MethodSpecsGatewayCardIcon */.cN
            }, 
        ]
    },
    {
        slug: "fx-trading",
        metaTitleSuffix: "FX / Trading",
        docDescription: "Fast deposits and withdrawals for trading platforms, with robust verification and multi-currency support.",
        solutionEyebrowLabel: "SOLUTION / FX / TRADING",
        headline: "Instant Funding for Fast Movers",
        subheadline: "In trading, every second counts. Provide your clients with instant deposits and rapid withdrawals so they can react to market shifts without delay.",
        featuresSectionTitle: "Risk Management",
        ctaHeadline: "Ready to fund traders in real time?",
        ctaVisualCaption: "Move money at market speed",
        card: {
            title: "FX / trading",
            description: "High conversion checkout, fast payouts, and granular controls",
            Icon: TrendingUpV4Icon
        },
        features: [
            {
                id: "verification",
                title: "Multi-Level Verification",
                description: "Secure transaction validation for high-volume trades.",
                Icon: IntegrationsHeroIcons/* IntegrationsHeroShieldIcon */.Wm
            },
            {
                id: "risk",
                title: "High-Risk Expertise",
                description: "Specialized tools for managing high-risk environments.",
                Icon: MethodSpecsIcons/* MethodSpecsH2HIcon */.C$
            },
            {
                id: "multicurrency",
                title: "Multi-Currency Support",
                description: "Automatic conversion and global settlement.",
                Icon: IntegrationsHeroIcons/* IntegrationsHeroGlobeIcon */.KU
            }, 
        ]
    },
    {
        slug: "regulated-industries",
        metaTitleSuffix: "Regulated Industries",
        docDescription: "Transparent flows, reporting tailored to licensing, with dedicated support and pricing for highly regulated sectors.",
        solutionEyebrowLabel: "SOLUTION / REGULATED INDUSTRIES",
        headline: "Reliability Within the Legal Framework",
        subheadline: "We understand the nuances of licensed businesses. Our solution is tailored to meet strict reporting requirements and ensure full transparency of every payment flow.",
        featuresSectionTitle: "Tailored Approach",
        ctaHeadline: "Ready for compliant payment operations?",
        ctaVisualCaption: "Partners for regulated workflows",
        card: {
            title: "Regulated industries",
            description: "High conversion checkout, fast payouts, and granular controls",
            Icon: StatsChartV4Icon
        },
        features: [
            {
                id: "support",
                title: "Dedicated Support",
                description: "Personal account managers for complex use cases.",
                Icon: MethodSpecsIcons/* MethodSpecsP2PIcon */.p4
            },
            {
                id: "analytics",
                title: "Deep Analytics",
                description: "Comprehensive data exports for auditing purposes.",
                Icon: MethodSpecsIcons/* MethodSpecsH2HIcon */.C$
            },
            {
                id: "rates",
                title: "Custom Rates",
                description: "Flexible pricing models that account for industry-specific volumes.",
                Icon: MethodSpecsIcons/* MethodSpecsWalletIcon */.T3
            }, 
        ]
    }, 
];
var solutionPageSlugs = solutionPages.map(function(p) {
    return p.slug;
});
function getSolutionPageBySlug(slug) {
    return solutionPages.find(function(p) {
        return p.slug === slug;
    });
}


/***/ })

}]);